import React, { FC, useEffect, useState } from 'react';
import styles from './LandscapeIndicatorDescriptionPage.module.css';
import { LandscapeIndicatorDescriptionTemplate } from '../../templates';
import {
  getLanguageKey,
  LocalesLanguagesConstants,
} from '../../../locales/locales';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../store/store';
import Spinner from '../../atoms/Spinner/Spinner';
import {
  translateObject,
  TranslateParams,
} from '../../../store/translateAPI/translate/reducers/translate.slice';
import {
  fetchLandscapeIndicatorById,
  updateLandscapeIndicator,
} from '../../../store/landscapeAPI/landscape/reducers/landscape-indicator.slice';
import { LandscapeIndicatorResponseDto } from '../../../store/landscapeAPI/landscape/dto/response/landscape-indicator-response.dto';
import { LandscapeIndicatorUpdateRequestDto } from '../../../store/landscapeAPI/landscape/dto/request/landscape-indicator-update-request.dto';
interface LandscapeIndicatorDescriptionPageProps {}
interface TranslationResponse {
  description: string;
}

const LandscapeIndicatorDescriptionPage: FC<
  LandscapeIndicatorDescriptionPageProps
> = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { id, landscapeIndicatorId } = useParams();
  const [selectedLanguage, setLanguage] = useState<LocalesLanguagesConstants>(
    LocalesLanguagesConstants.en
  );
  const [fromLanguage, setFromLanguage] = useState<LocalesLanguagesConstants>(
    LocalesLanguagesConstants.en
  );
  const [toLanguage, setToLanguage] = useState<LocalesLanguagesConstants>(
    LocalesLanguagesConstants.en
  );
  const { status } = useSelector(
    (state: RootState) => state.verificationStatusSlice
  );

  const [landscapeIndicator, setLandscapeIndicator] =
    useState<LandscapeIndicatorResponseDto | null>();

  useEffect(() => {
    if (!landscapeIndicatorId) {
      return;
    }
    dispatch(
      fetchLandscapeIndicatorById({
        id: landscapeIndicatorId,
        language: selectedLanguage,
      })
    )
      .unwrap()
      .then((resp) => {
        if (resp) {
          setLandscapeIndicator(resp);
        }
      });
  }, [landscapeIndicatorId, dispatch, selectedLanguage]);

  const translate = async (toLanguage: LocalesLanguagesConstants) => {
    if (!landscapeIndicator) return;
    const params: TranslateParams<{ description: string }> = {
      obj: { description: landscapeIndicator.description },
      from: getLanguageKey(fromLanguage)!,
      to: [getLanguageKey(toLanguage)!],
    };
    const response = (await dispatch(
      translateObject(params)
    ).unwrap()) as TranslationResponse;

    const { description } = response;

    const updateRequest: LandscapeIndicatorUpdateRequestDto = {
      id: landscapeIndicator.id,
      compactId: landscapeIndicator.compactId,
      indicatorId: landscapeIndicator.indicatorId,
      published: true,
      description: description,
      sortOrder: landscapeIndicator.sortOrder,
    };

    await dispatch(updateLandscapeIndicator(updateRequest));
    setLanguage(toLanguage);
  };

  const generateAllTranslations = async () => {
    return await Promise.allSettled(
      Object.values(LocalesLanguagesConstants).map(translate)
    );
  };

  const generateTranslation = async () => {
    return await translate(toLanguage);
  };

  const callbackFn = async () => {
    dispatch(
      updateLandscapeIndicator({
        id: landscapeIndicator?.id!,
        indicatorId: landscapeIndicator?.indicatorId!,
        compactId: landscapeIndicator?.compactId!,
        sortOrder: landscapeIndicator?.sortOrder!,
        published: true,
        description: landscapeIndicator?.description!,
      })
    );
    navigate(`/landscapes/edit/${id}/indicators`);
  };

  if (status === 'loading') {
    return <Spinner />;
  }

  return (
    <>
      {landscapeIndicator && (
        <div className={styles.wrapper}>
          <LandscapeIndicatorDescriptionTemplate
            setLanguage={setLanguage}
            selectedLanguage={selectedLanguage}
            fromLanguage={fromLanguage}
            setFromLanguage={setFromLanguage}
            toLanguage={toLanguage}
            setToLanguage={setToLanguage}
            generateTranslation={generateTranslation}
            generateAllTranslations={generateAllTranslations}
            description={landscapeIndicator.description}
            setDescription={(desc) => {
              if (landscapeIndicator) {
                setLandscapeIndicator({
                  ...landscapeIndicator,
                  description: desc,
                });
              }
            }}
            callbackFn={callbackFn}
          />
        </div>
      )}
    </>
  );
};

export default LandscapeIndicatorDescriptionPage;
